module.exports = __webpack_public_path__ + "static/media/ca_privacy_icon.83467031.svg";